import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {FaqArticle} from '../../../model/faq-article';
import {RouterLink} from "@angular/router";
import {CommonModule} from "@angular/common";
import {UrlDecodePipe} from "../UrlDecodePipe";

@Component({
    selector: 'app-faq-article-display',
    templateUrl: './faq-article-display.component.html',
    imports: [
        CommonModule,
        RouterLink,
        UrlDecodePipe
    ],
    styleUrls: ['./faq-article-display.component.css']
})
export class FaqArticleDisplayComponent implements AfterViewInit {

  @Input() article: FaqArticle;
  @Input() showFooter = true;
  @Output() goBack = new EventEmitter<void>();
  @ViewChild('display') display;
  @ViewChild('maintitle') maintitle;
  @ViewChild('summarymenu') summarymenu;

  @Input() set scrollOf(element: any) {
    element.addEventListener('scroll', this.listenToScroll);
  }

  summary: { tag, text, id, element }[] = [];
  activeIndex = 0;

  constructor(public cd: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    this.summary.push({
      tag: this.maintitle.nativeElement.tagName,
      text: this.maintitle.nativeElement.innerText,
      id: 'maintitle',
      element: this.maintitle.nativeElement,
    });

    let id = 0;
    for (const el of this.display.nativeElement.children) {
      if (el.tagName === 'H1' || el.tagName === 'H2' || el.tagName === 'H3' || el.tagName === 'H4' || el.tagName === 'H5') {
        const idstr = 'title' + (id++);
        this.summary.push({
          tag: el.tagName,
          text: el.innerText,
          id: idstr,
          element: el
        });
        el.id = idstr;
      }
    }
    this.cd.detectChanges();
  }

  doGoBack(): void {
    this.goBack.emit();
  }

  scrollTo(menu, index): void {
    window.scrollTo(0, menu.element.offsetParent.offsetTop + menu.element.offsetTop);
    setTimeout(() => {
      this.activeIndex = index;
    }, 0);
  }

  @HostListener('window:scroll', [])
  listenToScroll(): void {
    // find the min negative
    let activeElement;
    let negativeMini = 0;
    this.summary.forEach(s => {
      const rect = s.element.getBoundingClientRect();
      const pos = rect.top - rect.height;
      if (activeElement === undefined || pos < 0 && pos > negativeMini) {
        activeElement = s;
        negativeMini = pos;
      }
    });
    for (const el of this.summarymenu.nativeElement.children) {
      if (el.classList.contains('active')) {
        el.scrollIntoView({block: 'nearest'});
      }
    }
    this.activeIndex = this.summary.indexOf(activeElement);
  }

}
